"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRegionToSelectOptionLabel = void 0;
const transformCurrencyToSign_1 = require("./transformCurrencyToSign");
function transformRegionToSelectOptionLabel(region, currency) {
    const currencySign = (0, transformCurrencyToSign_1.transformCurrencyToSign)(currency);
    return `${region.englishName} (${currencySign}${region.guidePrice}/h & ${currencySign}${region.guideLocationPrice}/h for locations)`;
}
exports.transformRegionToSelectOptionLabel = transformRegionToSelectOptionLabel;
//# sourceMappingURL=transformRegionToSelectOptionLabel.js.map